import React from "react";
import HeaderCompound from "../compounds/HeaderCompound";
import JumboCompound from "../compounds/JumboCompound";
import InternetPlans from "../compounds/InternetPlans";
import CoverageAreas from "../compounds/CoverageAreas";
import ContactForm from "../compounds/ContactForm";
import CustomerSupport from "../compounds/CustomerSupport";
import Footer from "../compounds/Footer";

function HomePage() {
  return (
    <>
      <HeaderCompound />
      <div className="container">
        <div id="onceplay">
          <JumboCompound />
        </div>
        <div id="planes" className="container-planes">
          <div className="new-device">
            <h1 className="feature-heading-new-2">
              Elige el plan ideal para ti
              <br />
            </h1>
          </div>
          <InternetPlans />
        </div>
        <div id="cobertura">
          <div className="new-device">
            <h1 className="feature-heading-plan">Estamos contigo en Manabí</h1>
          </div>
          <CoverageAreas />
        </div>
        <div id="contactanos" className="container-contactanos">
          <div className="new-device">
            <h1 className="feature-heading-new-2">
              ¿Desea hacernos una consulta?
              <br />
            </h1>
          </div>
          <ContactForm />
        </div>
        <div id="contactanos" className="container-customer-suppor">
          <CustomerSupport />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default HomePage;
